const initialState = {
    tourHeaderComponentState: false
}
const tourStateReducer = (state = initialState, action) => {
    if (action.type === "TOUR_STATE") {
        return {
            ...state,
            ...action.payload
        }
    } else {
        return state
    }
}

export default tourStateReducer